<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-row style="margin-bottom:12px">
                <el-button size="small" v-on:click="add()" type="primary">添加</el-button>
            </el-row>
            <el-form ref="queryParams" inline label-position="right" label-width="80px" v-model="queryParams">
                <el-form-item label="所在仓库">
                    <el-input size="small" v-model="queryParams.warehouseName" placeholder="所在仓库" style="width: 120px" />
                </el-form-item>
                <el-form-item label="登录名">
                    <el-input size="small" v-model="queryParams.loginName" placeholder="登录名" style="width: 120px" />
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input size="small" v-model="queryParams.phone" placeholder="手机号码" style="width: 120px" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select size="small" v-model="queryParams.state" style="width: 120px">
                        <el-option value="1" label="启用">启用</el-option>
                        <el-option value="0" label="禁用">禁用</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" v-on:click="search()" type="primary">搜索</el-button>
                    <el-button size="small" v-on:click="reset()">重置</el-button>
                </el-form-item>
            </el-form>
            <Table :loading="loading" :columns="columns" :data="warehouseUsers" border>
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
        </Content>
        <Modal title="编辑" v-model="modalEdit" :closable="false" width="600px">
            <el-form ref="warehouseUser" label-position="right" label-width="80px" :model="warehouseUser" :rules="rules">
                <input type="hidden" :model="warehouseUser.id">
                <el-form-item label="仓库选择" prop="warehouseId">
                    <el-select v-model="warehouseUser.warehouseId" style="width: 240px" filterable :remote-method="remoteMethod1" :loading="loading1">
                        <el-option :label="option.name" v-for="(option, index) in warehouses" :value="option.id" :key="index">{{option.name}}
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="登录名" prop="loginName">
                    <el-input size="small" v-model="warehouseUser.loginName" placeholder="登录名" :disabled="warehouseUser.id>0" style="width: 240px" />
                    <font>用来登陆，不可重复，不可修改</font>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                    <el-input size="small" v-model="warehouseUser.phone" placeholder="手机号码" style="width: 240px" />
                </el-form-item>
                <el-form-item label="密码" prop="passport">
                    <el-input size="small" v-model="warehouseUser.passport" placeholder="" style="width: 240px" />
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <RadioGroup v-model="warehouseUser.state">
                        <Radio :label="1">
                            <span>启用</span>
                        </Radio>
                        <Radio :label="0">
                            <span>禁用</span>
                        </Radio>
                    </RadioGroup>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="cancel">取消</el-button>
                <el-button size="small" type="primary" :loading="modalLoading" @click="ok">确定</el-button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name: 'WarehouseUser',
    data() {
        return {
            loading1: false,
            loading: false,
            modalEdit: false,
            modalLoading: false,
            warehouses: [],
            queryParams: {

            },
            others: {

            },
            warehouseUser: {
                state: 1
            },
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            warehouseUsers: [

            ],
            rules: {
                warehouseId: [{ required: true, message: '请选择仓库' }],

                loginName: [{ required: true, message: '登录名不能为空' }],
                phone: [{ required: true, message: '手机号码不能为空' }],
                passport: [{ required: true, message: '密码不能为空' }]
            },
            columns: [{
                    title: '仓库',
                    key: 'warehouseName',
                    width: 180,
                    align: 'center'
                }, {
                    title: '登录名',
                    key: 'loginName',
                    width: 180,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var btns = [];
                        if (row.main == 1) {
                            btns.push(h("div", { style: { color: "#ff0000" } }, "主管理员"));
                        }
                        btns.push(h("div", { style: {} }, params.row.loginName));
                        return h("div", btns);
                    }
                }, {
                    title: '手机号码',
                    key: 'phone',
                    width: 130,
                    align: 'center'
                }, {
                    title: '状态',
                    key: 'state',
                    width: 130,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var text = "启用";
                        var styles = { color: '#fff', padding: '2px' };
                        if (row.state == 0) {
                            text = "禁用";
                            styles.backgroundColor = "#bbbec4";
                        } else {
                            styles.backgroundColor = "#5cb85c";
                        }
                        return h("div", [
                            h("span", { style: styles }, text)

                        ]);
                    }
                }, {
                    title: '最后登录时间',
                    key: 'lastLogin',
                    width: 130,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [
                            h("span", { style: {} }, me.long2datetime(params.row.lastLogin))
                        ]);
                    }
                }, {
                    title: '操作',
                    key: 'state',
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var btns = [];
                        if (row.main == 1) {
                            return h("div", "不可操作");

                        }
                        if (row.state == 1) {
                            btns.push(h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "error" }, on: { click: () => { this.delete(row.id, 0); } } }, "禁用"));
                        } else {
                            btns.push(h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "success" }, on: { click: () => { this.delete(row.id, 1); } } }, "启用"));
                        }
                        btns.push(h("Button", { style: { marginRight: "5px" }, props: { size: "small", }, on: { click: () => { this.edit(row); } } }, "修改"));

                        return h("div", btns);
                    }
                }

            ]
        };
    },
    mounted: function() {
        this.getList();
        this.getWarehouseList();

    },
    methods: {
        getWarehouseList: function(query) {
            var me = this;
            me.loading1 = true;
            me.$http.post("/ware/warehouse/getall.action", { warehouseName: query }).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.warehouses = body.obj;

                }
                me.loading1 = false;
            }, response => {
                me.loading1 = false;
            });

        },
        remoteMethod1: function(query) {
            var me = this;
            if (query != '') {
               this.getWarehouseList();
            } else {
                me.warehouses = [];
            }
        },
        cbtime: function(value) {
            this.others;
        },
        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {
            this.queryParams = {};
            this.getList();
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },

        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/user/getlist.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.warehouseUsers = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        delete: function(id, state) {
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否执行该操作",
                onOk: function() {
                    me.$http.post("/ware/user/state.action", { id: id, state: state }).then(response => {
                        var body = response;
                        if (body.status == 0) {
                            me.getList();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }, response => {

                    });
                },
                onCancel: function() {

                }
            });
        },
        edit: function(row) {
            this.warehouseUser = row;
            this.modalEdit = true;
        },
        add: function() {
            this.warehouseUser = { state: 1 };
            this.modalEdit = true;
        },
        ok: function() {
            var ok = false;
            this.$refs['warehouseUser'].validate((valid) => {
                ok = valid;
                if (valid) {

                } else {
                    this.$Message.error('请认真填写数据');
                }
            })
            if (!ok) return;
            var me = this;

            me.modalLoading = true;
            me.$http.post("/ware/user/doSave.action", me.warehouseUser).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.$Message.success("保存成功！");
                    me.getList();
                    me.modalEdit = false;

                } else {
                    me.$Message.error("操作异常!" + body.info);
                }
                me.modalLoading = false;
            }, response => {
                me.modalLoading = false;
            });
        },
        cancel: function() {
            this.warehouseUser = {};
            this.modalLoading = false;
            this.modalEdit = false;
        }
    }
}
</script>
<style scoped>
</style>